import * as React from "react";
import * as Styled from "./SpacerStyles";
var Spacer = function (_a) {
    var size = _a.size;
    return React.createElement(Styled.Spacer, { size: size });
};
export default Spacer;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiU3BhY2VyLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiU3BhY2VyLnRzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQSxPQUFPLEtBQUssS0FBSyxNQUFNLE9BQU8sQ0FBQztBQUMvQixPQUFPLEtBQUssTUFBTSxNQUFNLGdCQUFnQixDQUFDO0FBTXpDLElBQU0sTUFBTSxHQUFHLFVBQUMsRUFBaUI7UUFBZixJQUFJLFVBQUE7SUFDcEIsT0FBTyxvQkFBQyxNQUFNLENBQUMsTUFBTSxJQUFDLElBQUksRUFBRSxJQUFJLEdBQUksQ0FBQztBQUN2QyxDQUFDLENBQUM7QUFFRixlQUFlLE1BQU0sQ0FBQyJ9